import React, { useEffect, useState } from "react";
import { Table, Spinner } from "react-bootstrap";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import "./orderdetails.css";
import { Link,useHistory } from "react-router-dom";
import moment from "moment";
import swal from "sweetalert";
export default function OrderDetailsFood(props) {
  const { id } = props.match.params;
  const history=useHistory()
  const [orderData, setOrderData] = useState("");
  const [customer, setCustomer] = useState("");
  const [rider, setRider] = useState("");
  const [loader, setLoader] = useState(true);
  var amt = 0;
  var monthArr = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  };
  function getData() {
    axios
      .get(`${Baseurl.baseurl}/go-porter/get-porter-order-by-id/${id}`)
      .then((res) => {
        console.log("ordre",res.data.porterOrder)
        setOrderData(res.data.porterOrder);
        
        axios
          .get(
            `${Baseurl.baseurl}/user/get-user-by-id/${res.data.porterOrder.Customer}`
          )
          .then((response) => {
            setCustomer(response.data.user);
          })
          .catch((err) => {});
        axios
          .get(
            Baseurl.baseurl +
              `/rider/get-rider-by-id/${res.data.porterOrder.OrderDeliveryBoy}`
          )
          .then((response) => {
            setRider(response.data.data);

            setLoader(false);
          });
      })
      .catch((err) => {});
  }
  useEffect(() => {
    getData();
  }, []);
  function printBill(e) {
    e.preventDefault();
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    window.location.reload();
    document.body.innerHTML = originalContents;
  }
  function printThermalBill(e) {
    e.preventDefault();
    let printContents = document.getElementById("vikki").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    var css = `@media only print{
      #vikki { width:50%,height:50%}
   }`,
      head = document.head || document.getElementsByTagName("head")[0],
      style = document.createElement("style");

    style.type = "text/css";
    style.media = "print";

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
    window.print();
    window.location.reload();
    document.body.innerHTML = originalContents;
  }
  function assignRiderFoodOrder(){
    let assignData={
      orderId:id
    }
    axios
      .put(`${Baseurl.baseurl}/rider/reassign-food-order-rider`,assignData)
      .then((res) => {  
        if(res.data.status){
          axios
          .post( `${Baseurl.baseurl}/rider/send-food-rider-notification`,assignData )
          .then((response) => {
           if(response.data.status){
            swal("Added", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
           }
           else
           {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
           }
          })
          .catch((err) => {});
        }
        else
        {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        
        
       
      })
      .catch((err) => {});
  }
  return (
    <>
      {loader ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          
          <div className="row m-0 p-0">
          <i onClick={()=>{history.goBack()}} className="fa fa-arrow-left mr-4 mt-1" style={{cursor:"pointer"}}></i>
            <button
              onClick={(e) => {
                printBill(e);
              }}
              style={{
                borderRadius: 4,
                fontSize: 12,
                backgroundColor: "#2ebf91",
                color: "white",
              }}
              className="btn  text-center p-1 mb-3 "
            >
              Print Bill
            </button>
            <button
              onClick={(e) => {
                printThermalBill(e);
              }}
              style={{
                borderRadius: 4,
                fontSize: 12,
                backgroundColor: "#2ebf91",
                color: "white",
              }}
              className="btn  text-center p-1 mb-3 ml-3 "
            >
              Print Thermal Bill
            </button>
          </div>
          <div className="row">
            <div className="col-sm-6" id="printablediv">
              <div className="card " style={{ borderRadius: 4, padding: 8 }}>
                <div className="row">
                  <div
                    className="col-sm-6"
                    style={{
                      fontWeight: "bolder",
                      color: "#455a64",
                      fontSize: 18,
                    }}
                  >
                    {orderData.Address[0].Name}
                  </div>
                 
                  <div className="col-sm-6">
                    <div className="row">
                      <div
                        style={{
                          fontWeight: "bold",
                          color: "#455a64",
                          fontSize: 13,
                        }}
                      >
                        Order Date:
                      </div>
                      <div
                        className=" ml-2"
                        style={{
                          fontWeight: "600",
                          color: "#455a64",
                          fontSize: 11,
                          marginTop: 3,
                        }}
                      >
                        {orderData.Date}-{orderData.Month}-{orderData.Year}{" "}
                        {orderData.Hour}:{orderData.Minute}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                <div
                    className="col-sm-6"
                    style={{
                      fontWeight: "500",
                      color: "#455a64",
                      fontSize: 12,
                    }}
                  >
                    {orderData.Address[0].Address}
                    {orderData.Address[0].AreaName} 
                    {orderData.Address[0].CityName}
                  </div>
                </div>
                <div className="row">
                  <div
                    style={{ color: "#455a64", fontWeight: 'bold', fontSize: 13,marginTop:7 }}
                    className="col-sm-12"
                  >
                    {orderData._id}
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-6">
                    <div
                      style={{
                        color: "#455a64",
                        fontWeight: 600,
                        fontSize: 17,
                      }}
                    >
                      Customer Details
                    </div>
                    <div className="col-sm-12">
                      <div className="row" style={{ padding: 4 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#455a64",
                            fontSize: 13,
                          }}
                        >
                          Name:
                        </div>
                        <div
                          className=" ml-2"
                          style={{
                            fontWeight: "500",
                            color: "#455a64",
                            fontSize: 11,
                            marginTop: 3,
                          }}
                        >
                          {customer.Name}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="row" style={{ padding: 4 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#455a64",
                            fontSize: 13,
                          }}
                        >
                          Email:
                        </div>
                        <div
                          className=" ml-2"
                          style={{
                            fontWeight: "500",
                            color: "#455a64",
                            fontSize: 11,
                            marginTop: 3,
                          }}
                        >
                          {customer.Email}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="row" style={{ padding: 4 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#455a64",
                            fontSize: 13,
                          }}
                        >
                          Contact Number:
                        </div>
                        <div
                          className=" ml-2"
                          style={{
                            fontWeight: "500",
                            color: "#455a64",
                            fontSize: 11,
                            marginTop: 3,
                          }}
                        >
                          +91 {customer.Phone}
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="row" style={{ padding: 4 }}>
                        <div
                          style={{
                            fontWeight: "bold",
                            color: "#455a64",
                            fontSize: 13,
                          }}
                        >
                          Delivery Address:
                        </div>
                        <div
                          className=" ml-2"
                          style={{
                            fontWeight: "500",
                            color: "#455a64",
                            fontSize: 11,
                            marginTop: 3,
                          }}
                        >
                          {orderData.Address && orderData.Address[1].Address}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6 ">
                    <div className="row p-0">
                      <div className="col-sm-12 ">
                        <div
                          className="card-body text-center"
                          style={{
                            borderRadius: 4,
                            padding: 8,
                            color: "#455a64",
                            fontWeight: 600,
                            fontSize: 13,
                            border: "1px solid #999",
                           
                          }}
                        >
                          STATUS
                        </div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-sm-12">
                        <div
                          className="card text-center"
                          style={{
                            borderRadius: 4,
                            padding: 8,
                            color:orderData.OrderStatus==="Pending"?"red":orderData.OrderStatus==="Completed"?"#4caf50":"orange",
                            fontWeight: 600,
                            fontSize: 13,
                            border: "1px solid #999",
                          }}
                        >
                          {orderData.OrderStatus}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row p-0">
                          <div className="col-sm-12 ">
                            <div
                              className="card-body text-center"
                              style={{
                                borderRadius: 4,
                                padding: 8,
                                color: "#455a64",
                                fontWeight: 600,
                                fontSize: 11,
                                border: "1px solid #999",
                              }}
                            >
                              Order Type
                            </div>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-sm-12">
                            <div
                              className="card text-center"
                              style={{
                                borderRadius: 4,
                                padding: 8,
                                color: "#ff7043",
                                fontWeight: 600,
                                fontSize: 10,
                                border: "1px solid #999",
                              }}
                            >
                              {orderData.OrderType}
                            </div>
                          </div>
                        </div>
                      </div>
                      {orderData.PaymentType!==""&&(
                         <div className="col-sm-6">
                         <div className="row p-0">
                           <div className="col-sm-12 ">
                             <div
                               className="card-body text-center"
                               style={{
                                 borderRadius: 4,
                                 padding: 10,
                                 color: "#455a64",
                                 fontWeight: 600,
                                 fontSize: 8,
                                 border: "1px solid #999",
                               }}
                             >
                               Payment Mode
                             </div>
                           </div>
                         </div>
                         <div className="row ">
                           <div className="col-sm-12">
                             <div
                               className="card text-center"
                               style={{
                                 borderRadius: 4,
                                 padding: 8,
                                 color: "#ff7043",
                                 fontWeight: 600,
                                 fontSize: 10,
                                 border: "1px solid #999",
                               }}
                             >
                               {orderData.PaymentType}
                             </div>
                           </div>
                         </div>
                       </div>
                      )}
                     
                    </div>
                  </div>
                </div>
               <div id='vikki'>
               <div className="row">
                  {orderData.Item &&
                    orderData.Item.map((val) => {
                      amt = amt + val.ItemTaxPrice;
                      return (
                        <div className="col-sm-12">
                          <div
                            className="card bg-light"
                            style={{ borderRadius: 4, padding: 8 }}
                          >
                            <div className="row">
                              <div
                                className="col-sm-9"
                                style={{
                                  color: "#455a64",
                                  fontWeight: 600,
                                  fontSize: 16,
                                  fontFamily:'sans-serif'
                                }}
                              >
                                {val.Quantity} x {val.ItemName} ( ₹ {val.ItemTaxPrice})
                              </div>
                              <div
                                className="col-sm-3 "
                                style={{
                                  color: "#455a64",
                                  fontWeight: 600,
                                  fontSize: 16,
                                  fontFamily:'sans-serif'
                                }}
                              >
                                <div className="float-right">
                                  ₹ {val.ItemTaxPrice*val.Quantity}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className="row">
                  <div className="col-sm-6"></div>
                  <div className="col-sm-6">
                    <Table striped style={{ border: "#999 1px solid" }}>
                      <tr
                        style={{
                          color: "#455a64",
                          fontWeight: 600,
                          fontSize: 12,
                          fontFamily:'sans-serif'
                        }}
                      >
                        <td>SubTotal</td>
                        <td className="float-right">₹ {amt} </td>
                      </tr>
                      <tr
                        style={{
                          color: "#455a64",
                          fontWeight: 600,
                          fontSize: 12,
                          fontFamily:'sans-serif'
                        }}
                      >
                        <td>Store Charge</td>
                        <td className="float-right">
                          ₹ {orderData.ItemPackingTaxPrice}
                        </td>
                      </tr>
                      <tr
                        style={{
                          color: "#455a64",
                          fontWeight: 600,
                          fontSize: 12,
                          fontFamily:'sans-serif'
                        }}
                      >
                        <td>Delivery Charge</td>
                        <td className="float-right">
                          ₹{" "}
                          {orderData.RiderPrice &&
                            orderData.RiderPrice.RideFare +
                              orderData.RiderPrice.Tip}
                        </td>
                      </tr>
                      <tr
                        style={{
                          color: "#455a64",
                          fontWeight: 600,
                          fontSize: 12,
                          fontFamily:'sans-serif'
                        }}
                      >
                        <td>Total</td>
                        <td className="float-right">
                          ₹ {orderData.OrderPrice}
                        </td>
                      </tr>
                      <tr
                        style={{
                          color: "#455a64",
                          fontWeight: 600,
                          fontSize: 12,
                          fontFamily:'sans-serif'
                        }}
                      >
                        <td>Payable</td>
                        <td className="float-right">
                          ₹ {orderData.OrderPrice}
                        </td>
                      </tr>
                    </Table>
                  </div>
                </div>
               </div>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="row p-0">
                <div className="col-sm-12 ">
                  <div
                    className="card text-center"
                    style={{
                      borderRadius: 4,
                      padding: 16,
                      color: "#455a64",
                      fontWeight: 600,
                      fontSize: 15,
                    }}
                  >
                    Delivery Pin: {orderData.Code}
                  </div>
                </div>
              </div>
              <div className="row p-0">
                <div className="col-sm-12 ">
                  <div
                    className="card text-center"
                    style={{
                      borderRadius: 4,
                      padding: 16,
                      color: "#455a64",
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    Distance from Store to Customer:
                    <br />
                    {orderData.totalKM} km | {orderData.Duration} Mins
                  </div>
                </div>
              </div>
              {orderData.OrderStatus==="Pending"&&(
                <div className="row p-0">
                <div className="col-sm-12 ">
                  <div
                    className="card text-center"
                    style={{
                      borderRadius: 4,
                      padding: 16,
                      color: "#455a64",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    Order Actions
                    <div className="col-sm-12 p-1 mt-2 ">
                      <button
                        style={{ borderRadius: 4, fontSize: 12 }}
                        className="btn btn-danger text-center p-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              )}
              
              {orderData.OrderStatus==="Accepted"&&(
                 <div className="row p-0">
                 <div className="col-sm-12 ">
                   <div
                     className="card text-center"
                     style={{
                       borderRadius: 4,
                       padding: 16,
                       color: "#455a64",
                       fontWeight: 600,
                       fontSize: 16,
                     }}
                   >
                    <div  style={{
                      
                       color: "#455a64",
                       fontWeight: 600,
                       fontSize: 11,
                     }}>Reasign the order to another delivery boy</div>
                     <div className="col-sm-12 p-1 mt-2 ">
                       <button
                       onClick={()=>{assignRiderFoodOrder()}}
                         style={{
                           borderRadius: 4,
                           fontSize: 12,
                           backgroundColor: "#02c386",
                           color: "white",
                         }}
                         className="btn p-2  float-right "
                       >
                         Re-Assign
                       </button>
                     </div>
                   </div>
                 </div>
               </div>
              )}
                {orderData.Address[0].Photo.length!==0&&(
                 <div className="row p-0">
                 <div className="col-sm-12 ">
                   <div
                     className="card text-center"
                     style={{
                       borderRadius: 4,
                       padding: 16,
                       color: "#455a64",
                       fontWeight: 600,
                       fontSize: 16,
                     }}
                   >
                    <div style={{
                      
                      color: "#455a64",
                      fontWeight: 600,
                      fontSize: 13,
                    }}>Images from Restaurant</div>
                     
                      {orderData.Address[0].Photo.map((val)=>{
                        return(
                          <div className=" p-1 mt-2  ">
                          <img height={120} width={170} alt="" src={val} />
                          </div>
                        )
                      })}
                      
                   
                   </div>
                 </div>
               </div>
              )}
             
            </div>
            <div className="col-sm-3">
              <div className="row p-0">
                <div className="col-sm-12 ">
                  <div
                    className="card text-center"
                    style={{
                      borderRadius: 4,
                      padding: 16,
                      color:orderData.OrderStatus==="Pending"?"red":orderData.OrderStatus==="Completed"?"#4caf50":"orange",
                      fontWeight: 600,
                      fontSize: 15,
                    }}
                  >
                    <div>{orderData.OrderStatus} order</div>
                    <div
                      style={{ fontSize: 13, color: "grey", fontWeight: 500 }}
                    >
                      {moment([
                        orderData.Year,
                        monthArr[orderData.Month],
                        orderData.Date,
                      ]).fromNow()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row p-0">
                <div className="col-sm-12 ">
                  <div
                    className="card p-0"
                    style={{
                      borderRadius: 11,

                      fontWeight: 600,
                      fontSize: 11,
                    }}
                  >
                    <div class="progress">
                      <div class="circle done">
                        <div class="label_box">
                          <span class="label" style={{lineHeight:'26px'}}>S</span>
                          <span class="title">
                            {" "}
                            {rider?rider.riderFirstName:'No Rider Assigned'} {rider&&rider.riderPhone}
                          </span>
                        </div>
                      </div>
                      <span class="bar done"></span>
                      <div class="circle done">
                        <div class="label_box">
                          <span class="label" style={{lineHeight:'26px'}}>D</span>
                          <span class="title">
                            {customer.Name} {customer.Phone}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {orderData.Address[1].Photo.length!==0&&(
                 <div className="row p-0 mt-3">
                 <div className="col-sm-12 ">
                   <div
                     className="card text-center"
                     style={{
                       borderRadius: 4,
                       padding: 16,
                       color: "#455a64",
                       fontWeight: 600,
                       fontSize: 16,
                     }}
                   >
                    <div style={{
                      
                      color: "#455a64",
                      fontWeight: 600,
                      fontSize: 13,
                    }}>Images from Customer</div>
                     
                      {orderData.Address[1].Photo.map((val)=>{
                        return(
                          <div className=" p-1 mt-2  ">
                          <img height={120} width={170} alt="" src={val} />
                          </div>
                        )
                      })}
                      
                   
                   </div>
                 </div>
               </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
